import * as React from 'react'

import TextField, { TextFieldProps } from '@material-ui/core/TextField'
import { FormattedMessage }          from 'react-intl'

const EnhancedTextField = ({ helperText, label, ...rest }: TextFieldProps) => {
  const errorText =
    helperText &&
    (
      String(helperText).includes('http')
        ? <FormattedMessage id={`${helperText}`} />
        : <FormattedMessage id={`validation.${helperText}`} />
    )

  const phrasing = {
    errorText,
    label: <FormattedMessage id={`labels.${label}`} />,
  }

  return (
    <TextField
      helperText={phrasing.errorText}
      label={phrasing.label}
      {...rest}
    />
  )
}

export default EnhancedTextField



// WEBPACK FOOTER //
// ./src/components/atoms/EnhancedTextField.tsx